import React from 'react';
import Link from 'next/link';
import { NavigationMenuContent, NavigationMenuItem, NavigationMenuLink, NavigationMenuTrigger } from '@/shadcn/components/NavigationMenu';
import chartList, { pieChartMaker } from '@/features/resources/chartBuilderSettings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const charts = {
  hero: pieChartMaker,
  list: chartList.filter(chart => chart !== pieChartMaker)
};
export const ChartsDesktop = () => {
  return /*#__PURE__*/_jsxs(NavigationMenuItem, {
    children: [/*#__PURE__*/_jsx(NavigationMenuTrigger, {
      children: /*#__PURE__*/_jsx(Link, {
        href: '/charts',
        children: "Charts"
      })
    }), /*#__PURE__*/_jsx(NavigationMenuContent, {
      className: "min-w-[calc(100vw-4rem)] p-12 2xl:min-w-[calc(1400px-4rem)]",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex items-start justify-between gap-x-12",
        children: [/*#__PURE__*/_jsx(NavigationMenuLink, {
          href: `/${charts.hero.slug}`,
          className: "group w-1/3 max-w-[398px]",
          children: /*#__PURE__*/_jsxs("div", {
            className: "text-clip rounded-lg border border-input bg-white hover:bg-accent hover:text-accent-foreground",
            children: [/*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx("img", {
                src: charts.hero.images.openGraph,
                alt: charts.hero.images.resourceUrlAlt,
                className: "h-[190px] w-[398px] object-cover object-center"
              })
            }), /*#__PURE__*/_jsxs("div", {
              className: "p-5 xl:p-8",
              children: [/*#__PURE__*/_jsx("div", {
                className: "mb-2 text-base",
                children: charts.hero.title
              }), /*#__PURE__*/_jsx("div", {
                className: "text-sm font-normal text-muted-foreground",
                children: charts.hero.description
              })]
            })]
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "max-w-[760px] flex-1 pt-2.5",
          children: [/*#__PURE__*/_jsx("div", {
            className: "mb-10 text-xs uppercase tracking-widest text-muted-foreground",
            children: "Create free charts, graphs, and images."
          }), /*#__PURE__*/_jsx("div", {
            className: "grid grid-cols-2 gap-8",
            children: charts.list.map(chart => /*#__PURE__*/_jsxs(NavigationMenuLink, {
              href: `/${chart.slug}`,
              className: "group block",
              children: [/*#__PURE__*/_jsx("div", {
                className: "mb-5 group-hover:opacity-60",
                children: /*#__PURE__*/_jsx("img", {
                  className: "w-8",
                  src: chart.icon,
                  alt: chart.images.resourceUrlAlt
                })
              }), /*#__PURE__*/_jsx("div", {
                className: "mb-1 text-base",
                children: chart.heading
              }), /*#__PURE__*/_jsx("div", {
                className: "text-sm font-normal text-muted-foreground",
                children: chart.shortDescription
              })]
            }, `charts-${chart.slug}`))
          })]
        })]
      })
    })]
  });
};
export const ChartsMobile = _ref => {
  let {
    open,
    submenu
  } = _ref;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: open && submenu === 'charts' && /*#__PURE__*/_jsxs("div", {
      className: "flex fixed inset-0 top-[48px] w-full flex-col overflow-auto border-t border-border bg-white lg:hidden",
      children: [/*#__PURE__*/_jsxs("a", {
        href: "/pie-chart-maker",
        className: "block space-y-6 p-8",
        children: [/*#__PURE__*/_jsx("div", {
          className: "w-full text-clip rounded-lg text-center",
          children: /*#__PURE__*/_jsx("img", {
            src: charts.hero.images.resourceUrl,
            alt: charts.hero.images.resourceUrlAlt,
            className: "h-auto w-full max-w-[320px] mx-auto object-cover object-center"
          })
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("div", {
            className: "mb-2 text-base",
            children: charts.hero.title
          }), /*#__PURE__*/_jsx("div", {
            className: "text-sm font-normal text-muted-foreground",
            children: charts.hero.description
          })]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "px-8 py-3.5 text-xs uppercase tracking-widest text-muted-foreground",
        children: "Create free charts, graphs, and images."
      }), /*#__PURE__*/_jsx("div", {
        className: "border-t border-border pb-16",
        children: charts.list.map(chart => /*#__PURE__*/_jsxs("a", {
          href: `/${chart.slug}`,
          className: "group flex w-full items-start gap-x-4 border-b border-border px-8 py-7 text-left hover:bg-accent",
          children: [/*#__PURE__*/_jsx("div", {
            className: "shrink-0",
            children: /*#__PURE__*/_jsx("img", {
              className: "w-6",
              src: chart.icon,
              alt: chart.images.resourceUrlAlt
            })
          }), /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("div", {
              className: "mb-1.5 text-base",
              children: chart.title
            }), /*#__PURE__*/_jsx("div", {
              className: "text-sm font-normal text-muted-foreground",
              children: chart.description
            })]
          })]
        }, `charts-${chart.slug}`))
      })]
    })
  });
};